import React from 'react';
import { useSelectDropdownDividerStyles } from './SelectDropdownDivider.styles';

export const SelectDropdownDivider: React.FC = () => {
    const classes = useSelectDropdownDividerStyles();

    return <div className={classes.root} />;
};
